module.exports = __webpack_public_path__ + "img/svg/result-winner-background.8c90af6685d53149ab8a046a62e67bc1.svg";